export default __webpack_public_path__ + "images/prev-gray.svg?24ddcb52705eca8bf98678ee2a1b6b0c";